import documentScanStart from "./documentScanStart";
import myDocuments from "./myDocuments";

export default [documentScanStart, myDocuments];
